import {
	AfterContentChecked,
	AfterViewInit,
	Component,
	ElementRef,
	HostListener,
	OnInit,
	ViewChild
} from '@angular/core';
import {VehicleModelService} from '../services/vehicle-model.service';
import {Root} from '../model/vehiclemodel/Root';
import {Model} from '../model/vehiclemodel/Model';
import {Attribute} from '../model/vehiclemodel/Attribute';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {map, mergeMap} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ModelSlice} from '../model/slicemodel/ModelSlice';
import {Configparams} from '../model/configmodel/configparams'
import {ConfigService} from '../services/config.service';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {CheckBoxFlag} from '../model/CheckBoxFlag';
import {onLoadAnalytics} from "../adobe-analytics/analytics";
import {VehicleSliceEnum} from "../enum/VehicleSliceEnum";
import {AppConfigService} from "../config/app-config.service";
import * as ToolTipConstants from "../utils/constants";

@Component({
	selector: 'vehicles',
	templateUrl: './vehicles.component.html',
	styleUrls: ['./vehicles.component.scss'],
	standalone: false
})

export class VehiclesComponent implements OnInit, AfterContentChecked,AfterViewInit {
	pageOne = new FormGroup({})
	root: Root;
	year = (new Date()).getFullYear();
	imageToken: string;
	make: string;
	modelName: string;
	hasVehicle: boolean;
	ToolTipConstants = ToolTipConstants;
	selectedIndex = 0;
	attribute: Attribute[];
	vehicleWithImage: Model[] = []
	modelWithImage: ModelSlice[] = [];
	modelSliceList: ModelSlice[];
	vehicleImage: SafeUrl;
	isExpanding = false;
	active = false;
	showVehicles: Model[] = [];
	futureModels: string[] = [];
	currentModels: string[] = [];
	blackLabelVehicle: Model[] = [];
	powerSourceVehicle: Model[] = [];
	renderVehicleList = true;
	renderModel: boolean;
	modelPopoverTriggers = 'hover';
	vehicleForm: FormGroup;
	allModelSlice = new Map<Model, ModelSlice[]>();
	appConfig: Configparams
	modelSliceBaseURL2: string
	modelImage: SafeUrl;
	isSideNav = true;
	isMainNav = true;
	checkBoxConditions: CheckBoxFlag = {flag: false, hybridEngine: false, gasEngine: false};
	@ViewChild('vehicleList')
	vehicleList: ElementRef;
	listener: any;
	@ViewChild('sideNav') sideNav: ElementRef;
	@ViewChild('mainNav') mainNav: ElementRef;
	@ViewChild('vehList') vehList: ElementRef;
	modelNameList = [];
	environment:any
	isMobileView = true;
	scrHeight: any;
	scrWidth: any;
	@HostListener('window:resize', ['$event'])
	getScreenSize(event?) {
		this.scrHeight = window.innerHeight;
		this.scrWidth = window.innerWidth;
		this.updateTriggerForModel(window.innerWidth);
		if (this.scrWidth > 829) {
			this.isMobileView = true;
		} else{
			this.isMobileView = false;
		}
		// else if ((sessionStorage.getItem('isMobileView') === 'true')) {
		// 	this.isMobileView = false;
		// }
	}
	constructor(private readonly vehicleService: VehicleModelService, private readonly sanitizer: DomSanitizer, private readonly httpClient: HttpClient,
				fb: FormBuilder, private readonly configService: ConfigService, private readonly router: Router, public readonly dialog: MatDialog, private readonly appConfigService: AppConfigService) {
		this.vehicleForm = fb.group({
			gas: false,
			hybrid: false,
			isBlackLabel: false
		});
		this.environment = this.appConfigService.getBaseEndpoint();

		if (sessionStorage.getItem('isNavigate') !== 'true') {
			document.body.style.display = "none";
		}
		this.getScreenSize();
	}
	ngOnInit(): void {
		this.CollectAppConfigDetails();
		this.loadVehicleData();
		if ((sessionStorage.getItem('isMobileView') === 'true')) {
			if(this.scrWidth <= 829) {
				this.isMobileView = false;
			}
		}
		this.clearSession();
		setTimeout(() => {
			onLoadAnalytics(VehicleSliceEnum.page, VehicleSliceEnum.site_section
				, VehicleSliceEnum.hierarchy, VehicleSliceEnum.rule, VehicleSliceEnum.status, this.configService.getAppConfigValue().client
				, this.configService.getAppConfigValue().site);
		},4000);
	}
	ngAfterViewInit(): void {
		this.checkIfDomLoaded();
	}
	equalizeHeight() {
		if(this.scrWidth >= 829) {
			setTimeout(() => {
					const offsetHeight = document.getElementById('main-nav').clientHeight+23;
					document.getElementById('side-nav').style.height = offsetHeight + 'px'
				},
				100);
		}
	}
	loadVehicleData() {
		this.getVehicleImageServiceData().subscribe(data => {
			this.handleVehicleImageData(data);
		});
	}

	private handleVehicleImageData(data: any) {
		data.subscribe((vehicleModels) => {
			this.showVehicles = this.vehicleWithImage;
			this.getVehicleModelForYear(this.selectedIndex);
			this.fetchAndProcessModelSlice(vehicleModels);
		});
	}

	private fetchAndProcessModelSlice(vehicleModels: any) {
		this.vehicleService.getAllModelSlice(
			vehicleModels.Year,
			vehicleModels.ModelName,
			this.appConfig.modelsliceUrlBase1
		).subscribe(models => {
			this.processModelSlice(models, vehicleModels);
		});
	}

	private processModelSlice(models: any, vehicleModels: any) {
		const modelSlice = models.Response.Model.ModelSlices.ModelSlice;
		modelSlice.forEach((model) => {
			model.ImageToken = this.vehicleService.digUrl(model.ImageToken, 'HD-TILE', 'EXT', 4);
			model.year = vehicleModels.Year;
		});
		this.allModelSlice.set(vehicleModels, modelSlice);
	}

	ngAfterContentChecked() {
		if (this.checkBoxConditions.flag) {
			this.showBlackLabelOptions(this.checkBoxConditions.flag, this.selectedIndex)
		}
	}

	getVehicleImageServiceData() {
		const headers = {
			'application-id': 'bea997ee-7fdd-492f-a2db-d7f621b0f39c'
		};
		return this.httpClient.get<Root>(this.appConfig.vehicleCallUrl, {headers}).pipe(mergeMap(result => {
			this.root = result;
			this.showVehicles = this.root.Response.Model;
			this.showVehicles.sort((a, b) => {
				if (a.Pricing.Low.BaseMSRP !== b.Pricing.Low.BaseMSRP) {
					return Number(a.Pricing.Low.BaseMSRP) - Number(b.Pricing.Low.BaseMSRP);
				}
				else {
					return b.displayName?.localeCompare(a.displayName);
				}
			})
			return this.showVehicles.map((model: Model) => {
				if (model.Attribute?.Value) {
					model.displayName=model.Attribute.Value;
				}
				else{
					model.displayName=model.ModelName;
				}
				const imageUrl = this.vehicleService.getImageUrlWithOutToken(model.ModelName,model.Year);
				return this.vehicleService.getImage(imageUrl)
					.pipe(
						map(() => this.imageResponse(model))
					)
			})
		}))
	}

	private imageResponse(model: Model) {
		this.vehicleWithImage.push(model);
		return model;
	}

	getAttributeValue(attributes: Attribute[]) {
		return attributes.length > 1 ?
			attributes.filter(attribute => attribute.Value.includes('Image[|Lincoln')).map(attr => attr.Value).join(",") :
			attributes['Value'];
	}

	showBlackLabelOptions(checked: boolean, selectedIndex) {
		this.checkBoxConditions.flag = checked;
		this.allModelSlice.forEach((slice: ModelSlice[], vehicleModel: Model) => {
			slice.forEach((modelSlice) => {
				if (modelSlice.name.includes('Black Label') && this.blackLabelVehicle.includes(vehicleModel) === false) {
					this.blackLabelVehicle.push(vehicleModel);
				}
			});
		});
		this.getVehicleModelForYear(selectedIndex);
	}

	private includeFutureModels(item: Model, index) {
		const checkFutureYear: boolean = String(this.year + 1) === item.Year;
		const checkCurrentYear: boolean = String(this.year) === item.Year;
		const checkPreviousYear: boolean = item.Year === (this.year - 1).toString();

		if ((checkFutureYear && index === 0) ||
			(checkCurrentYear && index === 0 && (!this.futureModels.includes(item.ModelName))) ||
			(checkCurrentYear && index === 1 && (this.futureModels.includes(item.ModelName)))) {
			this.addVehicleList(item);
			return true;
		} else if ((checkPreviousYear && index === 1 && (this.modelNameList.includes(item.ModelName))) ||
			(checkPreviousYear && index === 0 && (!this.modelNameList.includes(item.ModelName)))){
			return true;
		}

		return false;
	}

	updateFutureModels(vehicles) {
		vehicles.forEach(vehicle => {
			const ifFutureModel: boolean = (vehicle.Year > String(this.year));
			const ifCurrentModel: boolean = (vehicle.Year === String(this.year));
			if (ifFutureModel) {
				if (!this.futureModels.includes(vehicle.ModelName)) {
					this.futureModels.push(vehicle.ModelName)
				}
			}
			if (ifCurrentModel) {
				if (!this.currentModels.includes(vehicle.ModelName)) {
					this.currentModels.push(vehicle.ModelName)
				}
			}
		})
	}

	private addVehicleList(item: Model) {
		if (this.modelNameList.indexOf(item.ModelName) === -1) {
			this.modelNameList.push(item.ModelName);
		}
	}

	getVehicleModelForYear(val) {
		this.selectedIndex = val;
		if (this.checkBoxConditions.flag && !this.checkBoxConditions.hybridEngine && !this.checkBoxConditions.gasEngine) {
			this.displayVehicles(val, this.blackLabelVehicle);
		} else if (!this.checkBoxConditions.flag && this.checkBoxConditions.hybridEngine && !this.checkBoxConditions.gasEngine) {
			this.displayVehicles(val, this.powerSourceVehicle);
		} else if (this.checkBoxConditions.flag && this.checkBoxConditions.hybridEngine && !this.checkBoxConditions.gasEngine) {
			this.displayVehicles(val, this.blackLabelVehicle.filter(item => this.powerSourceVehicle.indexOf(item) >= 0));
		} else if (this.checkBoxConditions.flag && ((!this.checkBoxConditions.hybridEngine && this.checkBoxConditions.gasEngine) ||
			(this.checkBoxConditions.hybridEngine && this.checkBoxConditions.gasEngine))) {
			this.displayVehicles(val, this.blackLabelVehicle);
		} else {
			this.displayVehicles(val, this.root.Response.Model);
		}
		this.equalizeHeight()
	}

	displayVehicles(val, vehiclesList: Model[]) {
		this.updateFutureModels(vehiclesList);
		this.showVehicles = vehiclesList.filter(vehicles => this.includeFutureModels(vehicles, val));
		this.showVehicles.sort((a, b) => {
			if (a.Pricing.Low.BaseMSRP !== b.Pricing.Low.BaseMSRP) {
				return Number(a.Pricing.Low.BaseMSRP) - Number(b.Pricing.Low.BaseMSRP);
			}
			else
			{
				return b.displayName?.localeCompare(a.displayName);
			}
		})
	}

	showPowerSource(val) {
		this.selectedIndex = val;
		this.checkBoxConditions.gasEngine = this.vehicleForm.controls['gas'].value;
		this.checkBoxConditions.hybridEngine = this.vehicleForm.controls['hybrid'].value;
		this.getPowerSource();
		this.getVehicleModelForYear(val);
	}

	private getPowerSource() {
		this.allModelSlice.forEach((slice: ModelSlice[], vehicleModel: Model) => {
			let attributes: Attribute[];
			slice.forEach(modelSlice => attributes = modelSlice.Attribute)
			if (attributes.length > 1) {
				attributes.filter((attribute) => attribute.Value.includes('Hybrid Transmission')).forEach((attribute) => {
					if (this.powerSourceVehicle.includes(vehicleModel) === false) {
						this.powerSourceVehicle.push(vehicleModel);
					}
				});
			} else if (this.powerSourceVehicle.includes(vehicleModel) === false) {
				this.powerSourceVehicle.push(vehicleModel);
			}
		})
	}
	CollectAppConfigDetails() {//To load configuration from config file based on US/CA
		this.appConfig = this.configService.getAppConfigValue();
		this.configService.getAppConfigValue().paymentCalTitle=''
		this.fetchValuesFromSession();
	}

	fetchValuesFromSession() {
		this.selectedIndex = Number(sessionStorage.getItem('selectedYear'))
		const isSessionBlackLablel = (sessionStorage.getItem('isBlackLabel') === 'true');
		if (isSessionBlackLablel) {
			this.vehicleForm.controls['isBlackLabel'].setValue(isSessionBlackLablel);
			this.checkBoxConditions.flag = this.vehicleForm.controls['isBlackLabel'].value;
		}
		this.modelName = sessionStorage.getItem('currentModelName');
		const previousYearFlag = sessionStorage.getItem('isNavigate') === 'true';
		if (previousYearFlag) {
			this.modelNameList = JSON.parse(sessionStorage.getItem('modelNameList'));
		}
	}

	showModels(modelName: string, year: string) {
		this.renderModel = true;
		this.renderVehicleList = false;
		this.allModelSlice.forEach((slice: ModelSlice[], vehicleModel: Model) => {
			if (vehicleModel.ModelName === modelName && vehicleModel.Year === year) {
				slice.forEach((modelSlice) => {
					const imageToken = modelSlice.ImageToken;
					const imageUrl = this.vehicleService.digUrl(imageToken, 'HD-THUMB', 'EXT', '4');
					this.vehicleService.getImage(imageUrl).subscribe(() => {
						this.modelWithImage.push(modelSlice);
					})

				})

			}
		});
		const navigationDetails: string[] = ['/vehicles/models'];
		this.router.navigate(navigationDetails);
	}
	previousPage() {
		this.renderModel = false;
		this.renderVehicleList = true;
		this.modelWithImage = [];
	}

	navigateModelTrim(modelData: Model) {
		sessionStorage.setItem("selectedYear", String(this.selectedIndex))
		sessionStorage.setItem("isBlackLabel", this.vehicleForm.controls['isBlackLabel'].value)
		sessionStorage.setItem('isNavigate', 'true')
		sessionStorage.setItem('modelNameList', JSON.stringify(this.modelNameList));
		sessionStorage.setItem('isMobileView', 'false');
		if (this.modelName !== 'undefined') {
			sessionStorage.setItem('currentModelName', this.modelName);
		}
		const navigationDetails: string[] = ['/finance/payment-calculator', modelData.Make, modelData.ModelName, modelData.Year];
		this.router.navigate(navigationDetails);
	}

	clearSession() {
		sessionStorage.removeItem('selectedYear');
		sessionStorage.removeItem('isBlackLabel');
		sessionStorage.removeItem('currentModelName');
		sessionStorage.removeItem('isNavigate');
		sessionStorage.removeItem('modelNameList');
		sessionStorage.removeItem('isMobileView');
	}

	public get height() {
		return window.innerHeight;
	}

	public get width() {
		return window.innerWidth < 768;
	}

	toggleScreen() {
		this.isMobileView = !this.isMobileView;
	}

	loadBlackLabelData(isBlackLabel: boolean) {
		if (isBlackLabel) {
			this.showBlackLabelOptions(isBlackLabel, this.selectedIndex)
		}
	}

	openDialog($event: MouseEvent, val: string) {
		this.vehicleService.getToolTipMsrp($event, val, this.vehList);
	}

	checkIfDomLoaded() {
		if(document.readyState === "complete") {
			this.equalizeHeight();
			document.body.style.display = "block";
		}
		else{
			setTimeout(()=>{
				this.checkIfDomLoaded();
			},1800)
		}
	}
	// addMSFTChatScript() {
	// 	const msftScript = document.createElement('script');
	// 	msftScript.src = 'https://oc-cdn-ocprod.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js';
	// 	msftScript.id = 'Microsoft_Omnichannel_LCWidget';
	// 	msftScript.setAttribute('data-app-id', this.environment.dataAppId);
	// 	msftScript.setAttribute('data-lcw-version', 'prod');
	// 	msftScript.setAttribute('data-org-id', this.environment.dataOrgId);
	// 	msftScript.setAttribute('data-org-url', this.environment.dataOrgUrl);
	// 	msftScript.async = true;
	// 	document.body.appendChild(msftScript);
	// }
	private updateTriggerForModel(screenWidth: number): void {
		this.modelPopoverTriggers = screenWidth <= 768 ? 'click' : 'hover';
	}
}
